import type {
  IContactFormFieldProps,
  IContactFormFunctionalityProps,
} from 'components/Contact/ContactFormTypes';
import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { ContactFormBody } from './ContactFormBody';
import { useContactForm } from './useContactForm';
import { useReseller } from 'hooks/Reseller/useReseller';

export const ContactForm: React.FC<IContactFormFieldProps & IContactFormFunctionalityProps> = ({
  onSuccess,
  onError,
  onLeadError,
  endpoint,
  ...formFieldProps
}) => {
  const { getValidationSchema, getInitialValues } = useContactForm(formFieldProps);

  const { contentfulReseller } = useReseller();

  return (
    <Formik
      validateOnBlur
      validateOnChange
      validateOnMount
      initialValues={getInitialValues()}
      enableReinitialize
      validationSchema={Yup.object().shape(getValidationSchema())}
      onSubmit={endpoint(onSuccess, onError, onLeadError, contentfulReseller)}
    >
      {props => <ContactFormBody {...props} fields={formFieldProps.formFields} />}
    </Formik>
  );
};
